import util from '@bmp-vue/core/api/util'
const controller = 'Revo'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  Get () {
    return [
      { modelo: 0, prazoInicio: 1, prazoFim: 23, taxa: 1.81 },
      { modelo: 0, prazoInicio: 24, prazoFim: 35, taxa: 1.54 },
      { modelo: 0, prazoInicio: 36, prazoFim: 47, taxa: 1.52 },
      { modelo: 0, prazoInicio: 48, prazoFim: 60, taxa: 1.46 },
      { modelo: 1, prazoInicio: 1, prazoFim: 23, taxa: 2.03 },
      { modelo: 1, prazoInicio: 24, prazoFim: 35, taxa: 1.68 },
      { modelo: 1, prazoInicio: 36, prazoFim: 47, taxa: 1.62 },
      { modelo: 1, prazoInicio: 48, prazoFim: 60, taxa: 1.62 },
      { modelo: 2, prazoInicio: 1, prazoFim: 23, taxa: 2.24 },
      { modelo: 2, prazoInicio: 24, prazoFim: 35, taxa: 1.79 },
      { modelo: 2, prazoInicio: 35, prazoFim: 47, taxa: 1.70 },
      { modelo: 2, prazoInicio: 48, prazoFim: 60, taxa: 1.67 },
      { modelo: 3, prazoInicio: 1, prazoFim: 23, taxa: 2.30 },
      { modelo: 3, prazoInicio: 24, prazoFim: 35, taxa: 1.86 },
      { modelo: 3, prazoInicio: 36, prazoFim: 47, taxa: 1.77 },
      { modelo: 3, prazoInicio: 48, prazoFim: 60, taxa: 1.71 }
    ]
  },
  ModeloCalculoEnum: {
    Price: 1,
    SAC: 2
  },
  ListaSituacaoDataBaseAprovada: [
    2, // Aprovada
    6, // Finalizada
    7, // Conferida
    8, // Liberada
    9, // Paga
    10, // Cedida
    11 // PendentePagamento
  ],

  SituacaoDataBaseAprovada: function (situacao) {
    var listaSituacao = ctrl.ListaSituacaoDataBaseAprovada
    return listaSituacao.includes(situacao)
  },
  Indexador: [
    { value: 1, text: 'CDI' },
    { value: 2, text: 'SELIC' },
    { value: 3, text: 'IPCA' },
    { value: 4, text: 'PTAX' },
    { value: 5, text: 'IGP-M' }
  ],
  bureaus: [
    { id: 0, value: 'databusca', text: 'DATA BUSCA' },
    { id: 1, value: 'serasa', text: 'SERASA' },
    { id: 2, value: 'scr', text: 'SCR BACEN' },
  ],
  validaBureaus (th, documentoCliente, bureaus, callback) {
    var dtoDataBusca = {
      consulta: {
        Documento: documentoCliente,
      },
    }

    const dataAtual = th.$api.UI.Format.Date(
      th.$api.UI.Date.AddDay(new Date(), -45),
      'yyyy-MM'
    )

    var dataBaseAno = dataAtual.split('-')[0]
    var dataBaseMes = dataAtual.split('-')[1]
    var dtoScr = {
      consulta: {
        Documento: documentoCliente,
        DataBaseAno: dataBaseAno,
        DataBaseMes: dataBaseMes,
      },
    }

    var dtoSerasa = {
      consulta: {
        Documento: documentoCliente,
      },
    }
    Promise.all([
      !bureaus.databusca || bureaus.databusca.HasError ? th.$api.Multiplo.Post('ConsultaDataBusca', dtoDataBusca) : null,
      !bureaus.scr || bureaus.scr.HasError ? th.$api.Multiplo.Post('ConsultaSCR', dtoScr) : null,
      !bureaus.serasa || bureaus.serasa.HasError ? th.$api.Multiplo.Post('ConsultaSerasa', dtoSerasa) : null,
    ]).then(response => {
      bureaus.databusca = response[0] || bureaus.databusca
      bureaus.scr = response[1] || bureaus.scr
      bureaus.serasa = response[2] || bureaus.serasa
      th.$set(th.model, 'DadosBureau', bureaus);
      callback()
    })
  },
  GetValorRegistro: async function (th, model) {
    if (!th.$param.EST_VALORES || !th.$param.EST_VALORES.Registro || th.$param.EST_VALORES.length === 0) { return }
    const registros = th.$param.EST_VALORES.Registro
    var vlrRegistro = 0
    const dto = { parameters: [{ name: 'CodigoProposta', value: model.Codigo }] }
    th.$set(model, 'VlrRegistro', 0)
    var response = await th.$api.Multiplo.Post('ListPropostaGarantiaBem', dto)
    if (th.$api.UI.PostLoadData(response)) {
      var tipoPessoa = th.$api.UI.Format.SomenteNumeros(model.Cliente.DocumentoFederal).length === 11 ? 1 : 2
      for (var i = 0; i < response.Data.length; i++) {
        vlrRegistro += await this.GetValorRegistroGarantia(th, response.Data[i], tipoPessoa, registros)
      }
      th.$set(model, 'VlrRegistro', vlrRegistro)
    }
  },
  GetItem (modelo, prazo) {
    return ctrl.Get().find(item => item.modelo === modelo && item.prazoInicio <= prazo && item.prazoFim >= prazo)
  },
  ChangeVlrProdutoBem (th, value) {
    let vlrEntrada = 0
    if (value) {
      value = th.$api.UI.Parse.Decimal(value)
      vlrEntrada = parseFloat((value * th.$param.VlrMinEntrada).toFixed(2))
    }
    th.$set(th.model, 'VlrEntrada', vlrEntrada)
  },
  SavePropostaCampoAuxiliar (th, campo) {
    const campos = []

    if ([null, undefined].indexOf(th.model.DtoConsultaMotor) < 0) { campos.push({ CodigoProposta: th.model.Codigo, NomeCampo: 'PROPOSTA_CONSULTAMOTOR', ValorCampo: JSON.stringify(th.model.DtoConsultaMotor) }) }

    return th.$api.Multiplo.Post('SavePropostaCampoAuxiliar', { dto: campos })
  },
  GetCampoAuxiliar (th, codigoProposta) {
    const dto = { parameters: [{ name: 'CodigoProposta', value: codigoProposta }] }
    return th.$api.Multiplo.Post('ListPropostaCampoAuxiliar', dto)
  },
  CarregaDiasAcrescimo (th, value) {
    const date = th.$api.UI.Date.AddDay(new Date(), value)
    th.model.nroDiasAcrescimoPrimPagto = th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), date)
  },
  tipoDoc: {
    Pessoa: [{ text: 'Documento de identificação aberto: CNH ou RG', value: 1, valueBmp: 8 },
      { text: 'Conta de luz do local de instalação', value: 2, valueBmp: 6 },
      { text: 'Comprovante de titularidade: IPTU ou RGI ou escritura', value: 8, valueBmp: 93 },
      { text: 'Comprovante de vínculo familiar (se necessário)', value: 4, valueBmp: 94 },
      { text: 'Nota fiscal do equipamento (kit)', value: 10, valueBmp: 50 },
      { text: 'Comprovante Renda (se necessário)', value: 3, valueBmp: 7 }],
    Fase1: [{ text: 'Parecer de acesso aprovado pela concessionária', value: 6, valueBmp: 74 },
      { text: 'Nota fiscal da mão de obra (serviço)', value: 9, valueBmp: 50 }],
    Fase2: [{ text: 'Comprovação  de start up/ monitoramento de sistema', value: 7, valueBmp: 75 },
      { text: 'Comprovante de aceite de vistoria do sistema', value: 5, valueBmp: 73 }]
  }
})

export default ctrl
